import { render, staticRenderFns } from "./TreatmentRecipeBase.vue?vue&type=template&id=76b930e8&scoped=true"
import script from "./TreatmentRecipeBase.vue?vue&type=script&lang=ts"
export * from "./TreatmentRecipeBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b930e8",
  null
  
)

export default component.exports